export default __webpack_public_path__ + "static/media/fb-insluiten.d6416931.jpg";